module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "message-dialog",
    attrs: {
      "title": _vm.pushType === 2 ? '紧急通知' : '消息详情',
      "visible": _vm.visible
    },
    on: {
      "update:visible": function($event) {
        _vm.visible = $event
      },
      "close": _vm.close
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('div', {
    staticClass: "m-head"
  }, [_c('p', {
    staticClass: "title",
    domProps: {
      "innerHTML": _vm._s(_vm.message.title)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "sub-title"
  }, [_vm._v(_vm._s(_vm.message.publish_time))])]), _vm._v(" "), _c('div', {
    staticClass: "m-body",
    domProps: {
      "innerHTML": _vm._s(_vm.message.content)
    }
  }), _vm._v(" "), (!_vm.pushType) ? _c('div', {
    staticClass: "m-footer"
  }, [(_vm.message.lastId || _vm.message.nextId) ? _c('span', [_vm._v("阅读：")]) : _vm._e(), _vm._v(" "), _c('span', [_c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.message.lastId),
      expression: "message.lastId"
    }],
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.updateId(_vm.message.lastId)
      }
    }
  }, [_vm._v("下一篇消息")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.message.nextId && _vm.message.lastId),
      expression: "message.nextId && message.lastId"
    }],
    staticClass: "spacer"
  }, [_vm._v("|")]), _vm._v(" "), _c('span', [_c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.message.nextId),
      expression: "message.nextId"
    }],
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.updateId(_vm.message.nextId)
      }
    }
  }, [_vm._v("上一篇消息")])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("知道了")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e1dbac1e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/MessageNav/MessageDialog.vue
// module id = 764
// module chunks = 8